<div class="PGUploadButton {{overlay ? 'PGUploadButton--Overlay' : ''}}">
    <label class="{{ buttonClass != null ? buttonClass : 'btn btn-primary' }} {{ disabled ? 'disabled' : '' }}" [attr.aria-disabled]="disabled || null">
        <i class="{{ buttonIcon != null ? buttonIcon : 'fa-regular fa-upload' }} me-2" aria-hidden="true"></i>
        <span>{{ buttonText != null ? buttonText : 'Upload' }}</span>
        @if (!directory) {
            <input type="file" [disabled]="disabled" #fileInput [accept]="accept" [multiple]="multiple" (change)="checkFiles()"
                [attr.aria-label]="buttonText != null ? buttonText : 'Upload'"/>
        }
        @if (directory) {
            <input type="file" [disabled]="disabled" #fileInput [attr.webkitdirectory]="directory" [attr.directory]="directory" (change)="checkFiles()"
                [attr.aria-label]="buttonText != null ? buttonText : 'Upload'"/>
        }
    </label>
</div>
